import { render, staticRenderFns } from "./OfferSelectsPallet.vue?vue&type=template&id=6f1a5376&scoped=true&"
import script from "./OfferSelectsPallet.vue?vue&type=script&lang=js&"
export * from "./OfferSelectsPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a5376",
  null
  
)

export default component.exports